"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsContainer = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ControlsContainer = ({ id, className, style, children, position = "bottom-left", }) => {
    const props = { className: `react-sigma-controls ${className ? className : ""} ${position}`, id, style };
    return react_1.default.createElement("div", Object.assign({}, props), children);
};
exports.ControlsContainer = ControlsContainer;
//# sourceMappingURL=ControlsContainer.js.map